module.exports = __webpack_public_path__ + "static/img/MV14.4f85c19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV14.jpg
// module id = 6iFi
// module chunks = 0